
import VForm from '@//CommonDP/VForm/utils/vform';
import nameEditorJyht from "./name-editor-jyht.vue";
import Vue from "vue";
export function replacePanel() {
  const { VFormSDK } = VForm;
  // 替换组件
  VFormSDK.PERegister.registerCommonProperty("name", "name-editor-jyht");
  Vue.component("name-editor-jyht", nameEditorJyht);
}
